var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_vm.type == 1 ? _c("div", [_c("a-row", [_c("a-col", {
    staticClass: "itemBox",
    attrs: {
      span: 12
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("修改前")) + " ")]), _c("a-col", {
    staticClass: "itemBox",
    attrs: {
      span: 12
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("修改后")) + " ")])], 1), _c("top-title", [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("产品信息")))])]), _c("code-diff", {
    attrs: {
      "old-string": _vm.old_value,
      "new-string": _vm.new_value,
      context: _vm.context,
      outputFormat: "side-by-side",
      renderNothingWhenEmpty: true,
      isShowNoChange: true
    }
  }), _c("top-title", [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("文案信息")))])]), _c("code-diff", {
    attrs: {
      "old-string": _vm.old_value2,
      "new-string": _vm.new_value2,
      context: _vm.context,
      outputFormat: "side-by-side",
      renderNothingWhenEmpty: true,
      isShowNoChange: true
    }
  }), _c("top-title", [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("富文本信息")))])]), _c("a-row", [_c("a-col", {
    attrs: {
      span: 12
    }
  }, _vm._l(_vm.copywriting, function (item, index) {
    return _c("a-form-model", {
      key: index,
      attrs: {
        "label-col": {
          span: 3
        }
      }
    }, [_c("a-form-model-item", {
      staticStyle: {
        display: "flex"
      },
      attrs: {
        label: item.name
      }
    }, [_c("quill-editor", {
      ref: "myTextEditor2",
      refInFor: true,
      staticStyle: {
        height: "400px"
      },
      attrs: {
        options: _vm.quillOption,
        disabled: true
      },
      model: {
        value: item.content,
        callback: function ($$v) {
          _vm.$set(item, "content", $$v);
        },
        expression: "item.content"
      }
    })], 1)], 1);
  }), 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, _vm._l(_vm.copywriting2, function (item, index) {
    return _c("a-form-model", {
      key: index,
      attrs: {
        "label-col": {
          span: 3
        }
      }
    }, [_c("a-form-model-item", {
      staticStyle: {
        display: "flex"
      },
      attrs: {
        label: item.name
      }
    }, [_c("quill-editor", {
      ref: "myTextEditor2",
      refInFor: true,
      staticStyle: {
        height: "400px"
      },
      attrs: {
        options: _vm.quillOption,
        disabled: true
      },
      model: {
        value: item.content,
        callback: function ($$v) {
          _vm.$set(item, "content", $$v);
        },
        expression: "item.content"
      }
    })], 1)], 1);
  }), 1)], 1), _c("top-title", [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("审核")))])]), _c("a-form-model", {
    attrs: {
      model: _vm.dataFrom,
      "label-col": {
        span: 3
      },
      "wrapper-col": {
        span: 18
      }
    }
  }, [_c("a-col", {
    attrs: {
      span: 24
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("审核意见")
    }
  }, [_c("a-textarea", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("审核意见"),
      "auto-size": {
        minRows: 5,
        maxRows: 10
      }
    },
    model: {
      value: _vm.dataFrom.content,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "content", $$v);
      },
      expression: "dataFrom.content"
    }
  })], 1)], 1), _c("a-col", {
    staticClass: "marginT20",
    staticStyle: {
      "padding-bottom": "100px"
    },
    attrs: {
      span: 24
    }
  }, [_c("a-form-model-item", {
    attrs: {
      "wrapper-col": {
        span: 10,
        offset: 8
      }
    }
  }, [_c("a-button", {
    attrs: {
      type: "danger"
    },
    on: {
      click: function ($event) {
        return _vm.onSubmit(4);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("驳回")))]), _c("a-button", {
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      type: "primary"
    },
    on: {
      click: function ($event) {
        return _vm.onSubmit(3);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("审核通过")))])], 1)], 1)], 1)], 1) : _c("div", [_c("line-info")], 1)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };